<template>
<b-row class="m-2">
    <b-col v-if="loaded === false">
         <template>
            <div class="OTloading">
                <div class="OTloader"></div>
            </div>
        </template>
    </b-col>
    <b-col v-else >
        <b-row>
            <b-col>
                <h1>{{ecmResourceStrings.ttlDetailedReports}}</h1>
            </b-col>
            <b-col>
                <div>{{ecmResourceStrings.ttlECMRepoName}} {{ecmrepositoryname}}</div>
            </b-col>
        </b-row>
        <b-row>
            <b-col class="OT-tabs">
                <SubNavbar :routes="routes"></SubNavbar>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <router-view :group="getname"></router-view>
            </b-col>
        </b-row>
    </b-col>
</b-row>
</template>

<script>

import axios from 'axios';
import configRouteMappings from '@/ecm/routing/oticConfigRoutes.js';
import SubNavbar from '@/ecm/components/settings/SubpageBar.vue';

export default {

    props: ['ecmrepositoryid', 'ecmrepositoryname', 'ecmrepositorytype'],

    components: {
        SubNavbar
    },

    data() {
        return {
            ecmResourceStrings: require('../../../utils/resourceECM.js'),  
            loaded: false,
        }
    },

    computed: {
        routes() {
            const routes = configRouteMappings['ECM Crawler Reports'];
            return routes;
        },

        getname(){
            var that = this;
            return "General";
        },
    },

    created() {
        var that = this;
        that.loaded = true;
    },
}
</script>
































